
import React from 'react';
import ProductList from '@/components/payment/ProductList';
import { AlertCircle, Info } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';

interface OfferProductListProps {
  offerProducts: any[];
  selectedProductIds: string[];
}

const OfferProductList: React.FC<OfferProductListProps> = ({
  offerProducts,
  selectedProductIds
}) => {
  
  if (offerProducts.length === 0) {
    return (
      <Alert variant="destructive" className="mb-8">
        <AlertCircle className="h-4 w-4" />
        <AlertDescription>
          No active products available for this offer. This could be because the products have been deleted, inactivated, or there's an issue with the product IDs.
        </AlertDescription>
      </Alert>
    );
  }
  
  // Check for cases where we have products but they're missing details
  const productsWithMissingDetails = offerProducts.filter(product => !product.details);
  if (offerProducts.length > 0 && productsWithMissingDetails.length > 0) {
    return (
      <div className="mb-8">
        <Alert variant="destructive" className="mb-4">
          <AlertCircle className="h-4 w-4" />
          <AlertDescription>
            Products found but product details are missing. Product IDs: {productsWithMissingDetails.map(p => p.product_id).join(', ')}
          </AlertDescription>
        </Alert>
        
        <div className="bg-amber-50 p-4 rounded-md border border-amber-200">
          <div className="flex items-start">
            <Info className="h-5 w-5 text-amber-500 mt-0.5 mr-2" />
            <div>
              <h4 className="font-medium text-amber-800">Debugging Information:</h4>
              <ul className="list-disc pl-5 text-sm text-amber-700 mt-1">
                {offerProducts.map((product, index) => (
                  <li key={index}>
                    {product.isSubscription ? '🔄 Subscription:' : '🛒 Product:'} 
                    ID={product.product_id || 'unknown'}, 
                    ProductId={product.productId || 'unknown'}, 
                    Details={product.details ? 'available' : 'missing'}
                    {product.details?.status && `, Status=${product.details.status}`}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
  return (
    <div className="mb-8">
      <ProductList 
        offerProducts={offerProducts}
        globalProducts={[]}
        selectedProductIds={selectedProductIds}
        showProductImages={true}
        isBundle={true}
      />
    </div>
  );
};

export default OfferProductList;
